import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";
import AppUser from "../app-user/app-user";

interface AriaTokenResponse {
  status: boolean;
  message: string;
  data?: {
    accessToken: string;
  };
  networkError: boolean;
}

async function getToken(): Promise<AriaTokenResponse> {
  try {
    const user = await AppUser.getInfo();
    // TODO: check the user data correct variables [alias, jobTitle, jobDescription]
    // Theses variables are to be added in the backend database
    const userData = {
      userId: user?.id ?? "",
      name: user?.name ?? "",
      alias: user?.alias ?? "",
      role: user?.role ?? "",
      programme: user?.programmeName ?? "",
      employer: user?.organizationName ?? "",
      jobTitle: user?.jobTitle ?? "",
      jobDescription: user?.jobDescription ?? "",
    };

    const response = await axios.post(
      apiUrl(`api/auth/auth-aria/jwt-validation`, "aria"),
      userData,
      await getAuthHeader()
    );

    const { data } = response;

    if (data.result !== "OK") {
      throw new Error(data.message ?? "Unable to fetch aria token");
    }

    return {
      status: true,
      message: "Successfully fetched token",
      data: data?.data,
      networkError: false
    };
  } catch (err: any) {
    const resMsg = err?.response?.data?.message;

    const isNetworkError = !err.response || err.code === 'NETWORK_ERROR' || err.code === 'ECONNABORTED';

    return {
      status: false,
      message: typeof resMsg === "string" ? resMsg : err.message,
      networkError: isNetworkError
    };
  }
}

const ApiARIAAuth = {
  getToken,
};

export default ApiARIAAuth;
